// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d6081bf3","644":"8e9634a0"}[chunkId] + ".chunk.js";
};